module.exports = __webpack_public_path__ + "static/media/potato-tomato-curry.6085e9d4.jpg";